module.exports = __webpack_public_path__ + "img/triangle-white-up.a43c59dd.svg";